import ChartCard from "./ChartCard";

const CategoryContainer = ({category, searchTerm}) => {
    return (
        <div className="categoryContainer">
                <div id={category.displayName.split(' ').join('-')} className="categoryTitle">
                    { category.displayName }
                </div>
                <div className="chartsContainer">
                    {
                        searchTerm.length
                        ? category.charts.filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase())).map(chart => <ChartCard key={chart.title} chart={chart} categoryDisplayName={category.displayName} />)
                        : category.charts.map(chart => <ChartCard key={chart.title} chart={chart} categoryDisplayName={category.displayName} />)
                    }
                </div>
        </div>
    );
}

export default CategoryContainer;